<template>
  <div>
    <Filters
      :status="currentStatus"
      @change="updateFilters"
    />

    <Table
      :items="items"
      :pagination="pagination"
      :status="currentStatus"
      :drawerVisibility="drawerVisibility"
      @reloadData="reloadData"
      @goToPage="updatePage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray } from 'utils/functions'
import Filters from './Filters'
import Table from './Table'

export default {
  name: 'ImportedSpreadsheets',
  components: {
    Filters,
    Table
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {
        search: null,
        status: null,
        useremail: null,
        username: null,
        createDate: null
      },
      currentStatus: null,
      items: [],
      selectedItem: null,
      drawerVisibility: true
    }
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    updatePagination (response, itemsPerPage) {
      this.pagination = {
        ...this.pagination,
        totalElements: response.totalElements,
        totalPages: response.totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const { search, status, useremail, username, createDate } = this.filters
        const { data: res } = await this.$apiService.getMassiveWorkerProcess(
          { page: currentPage - 1 },
          { limit: itemsPerPage },
          { search },
          { status },
          { useremail },
          { username },
          { createDate }
        )

        if (res && !res.valid) {
          throw new Error()
        }

        this.items = res && this.isValidArray(res.content) ? res.content : []
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.drawerVisibility = !this.drawerVisibility
      }
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>
